import React from "react";
import LegalPage from "../components/LegalPage";
import { useApp } from "../context/AppContext";
import { IMAGES } from "../data/mock";

const Impressum = () => {
  const { lang } = useApp();
  const de = {
    title: "Impressum",
    subtitle: "Rechtliche Angaben zu MYOWNCUVEE",
    sections: [
      { h: "Kontakt", body: ["MYOWNCUVEE c/o MYSYMP AG", "Oberdorfstrasse 18a, 6207 Nottwil, Schweiz", "E-Mail: info@myowncuvee.com", "Web: www.myowncuvee.com", "Telefon: +41 79 471 06 25"] },
      { h: "Geschäftsführung", body: "Isidoro Celentano, CEO / Gründer MYOWNCUVEE.COM" },
      { h: "Handelsregister", body: ["Eingetragener Firmenname: MYSYMP AG", "Nummer: CHE-192.170.455", "Handelsregisteramt: Nottwil"] },
      { h: "Mehrwertsteuer", body: "MWST-Nummer: CHE-192.170.455 MWST" },
    ],
  };
  const en = {
    title: "Legal Notice",
    subtitle: "Legal information about MYOWNCUVEE",
    sections: [
      { h: "Contact", body: ["MYOWNCUVEE c/o MYSYMP AG", "Oberdorfstrasse 18a, 6207 Nottwil, Switzerland", "Email: info@myowncuvee.com", "Web: www.myowncuvee.com", "Phone: +41 79 471 06 25"] },
      { h: "Managing Director", body: "Isidoro Celentano, CEO / Founder MYOWNCUVEE.COM" },
      { h: "Trade Register", body: ["Registered company name: MYSYMP AG", "Number: CHE-192.170.455", "Commercial Registry Office: Nottwil"] },
      { h: "VAT", body: "VAT number: CHE-192.170.455 MWST" },
    ],
  };
  const c = lang === "de" ? de : en;
  return <LegalPage title={c.title} subtitle={c.subtitle} image={IMAGES.cellar1} sections={c.sections} />;
};

export default Impressum;
